var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E2DFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8326 8.55561C12.8326 10.1112 11.6104 11.3334 10.0549 11.3334C8.4993 11.3334 7.27707 10.1112 7.27707 8.55561C7.27707 7.00005 8.4993 5.77783 10.0549 5.77783C11.6104 5.77783 12.8326 7.00005 12.8326 8.55561ZM11.7223 8.55552C11.7223 7.61107 11.0001 6.88885 10.0556 6.88885C9.11116 6.88885 8.38894 7.61107 8.38894 8.55552C8.38894 9.49996 9.11116 10.2222 10.0556 10.2222C11.0001 10.2222 11.7223 9.49996 11.7223 8.55552ZM14.7775 15.2223V16.3334C14.7775 16.6667 14.5552 16.8889 14.2219 16.8889C13.8886 16.8889 13.6663 16.6667 13.6663 16.3334V15.2223C13.6663 14.2778 12.9441 13.5556 11.9997 13.5556H8.11079C7.16634 13.5556 6.44412 14.2778 6.44412 15.2223V16.3334C6.44412 16.6667 6.2219 16.8889 5.88856 16.8889C5.55523 16.8889 5.33301 16.6667 5.33301 16.3334V15.2223C5.33301 13.6667 6.55523 12.4445 8.11079 12.4445H11.9997C13.5552 12.4445 14.7775 13.6667 14.7775 15.2223ZM16.2778 12.2778L18.5001 10.0556C18.7223 9.83339 18.7223 9.50005 18.5001 9.27783C18.2778 9.05561 17.9445 9.05561 17.7223 9.27783L15.8889 11.1112L15.1667 10.3889C14.9445 10.1667 14.6112 10.1667 14.3889 10.3889C14.1667 10.6112 14.1667 10.9445 14.3889 11.1667L15.5001 12.2778C15.6112 12.3889 15.7223 12.4445 15.8889 12.4445C16.0556 12.4445 16.1667 12.3889 16.2778 12.2778Z",
    fill: "#5B36F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendedIcon);
export default __webpack_public_path__ + "static/media/attended_icon.0abdde689bf2c8bbc28ef1201cc76fcb.svg";
export { ForwardRef as ReactComponent };